import React from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { logout } from '../actions/authActions'
import { filterSets } from "../actions/settings"

class NavigationBar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
      showSets: false,
      showReps: false,
      current: props.current
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.current !== this.props.current){
      this.setState({current: nextProps.current});
    }
  }

  logout = (e) => {
    e.preventDefault();
    this.props.logout();
  }

  toggleMenu = () => {
    this.setState({collapsed: !this.state.collapsed});
  }

  toggleSets = (e) => {
    e.preventDefault();

    if(this.state.showSets){
      this.setState({showSets: false});
      return false;
    }

    var hideSets = function(){
      this.setState({showSets: false});
      document.removeEventListener("click", hideSets);
    }.bind(this);

    this.setState({showSets: true});
    document.addEventListener("click", hideSets);
  }

  toggleReps = (e) => {
    e.preventDefault();

    if(this.state.showReps){
      this.setState({showReps: false});
      return false;
    }

    var hideReps = function(){
      this.setState({showReps: false});
      document.removeEventListener("click", hideReps);
    }.bind(this);

    this.setState({showReps: true});
    document.addEventListener("click", hideReps);
  }

  navigate = (page) => {
    this.setState({
      current: page,
      collapsed: true
    });
  }

  contractorClick = e => {
    this.props.filterSets('comp', {
      ...this.props.comps.filter,
      type: 'cost',
      srvc: null
    });
  }

  render() {
    const { isAuthenticated, user, menu, sets } = this.props.auth;
    const { saving, fetching } = this.props.dataState;
    const { collapsed, showSets, showReps, current } = this.state;

    const fetchingScreen = fetching.length > 0 ?
      <div
        className="progress progress-striped active"
        style={{
          position: 'fixed',
          width: '100%',
          zIndex: 1,
          height: '10px'
        }}
      >
        <div className="progress-bar" style={{width: '100%'}}></div>
      </div>
      : [];

    const savingScreen = saving.length > 0 ?
      <div className="modal" data-backdrop="static" data-keyboard="false"
        tabIndex="-1" role="dialog" aria-hidden="true"
        style={{
          paddingTop: '15%',
          overflowY: 'visible',
          backgroundColor: 'rgba(30,30,30,.7)',
          display:'block'
        }}>
        <div className="modal-dialog modal-m">
          <div className="modal-content">
            <div className="modal-header">
              <h3 style={{margin:0}}>Загрузка</h3>
            </div>
            <div className="modal-body">
              <div
                className="progress progress-striped active"
                style={{marginBottom:0}}
              >
                <div className="progress-bar" style={{width: '100%'}}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      : [];

    const navClass = collapsed ? '' : ' in';
    const displName = (
      user.hasOwnProperty('user_text')
      && user.user_fname.length>0
    ) ? user.user_fname : user.user_login;
    const mark = (
      user.hasOwnProperty('user_text')
      && user.user_fname.length>0
      && user.user_lname.length>0
      && user.user_tel.length>0
      && user.user_text.length>0
    ) ? <span className="glyphicon glyphicon-user"></span>
    : (
        <span
          style={{color:'orange'}}
          className="glyphicon glyphicon-exclamation-sign"
        ></span>
    );

    const links = menu.map(el => {
      if(el.action_name === 'report'){
        return (
          <li
            key='report'
            className={showReps ? 'dropdown open' : 'dropdown'}
          >
            <a
              href="#"
              onClick={this.toggleReps}
              aria-expanded={showReps ? 'true' : 'false'}
            >
              Отчеты <span className="caret"></span>
            </a>
            <ul className="dropdown-menu">
              <li
                className={current === 'payments' ? 'active' : ''}
                onClick={() => this.navigate('payments')}
              >
                <Link to="/payments">Платежи</Link>
              </li>
              <li
                className={current === 'abc' ? 'active' : ''}
                onClick={() => this.navigate('abc')}
              >
                <Link to="/abc">ABC анализ</Link>
              </li>
              <li
                className={current === 'income' ? 'active' : ''}
                onClick={() => this.navigate('income')}
              >
                <Link to="/income">Чистая прибыль</Link>
              </li>
              <li>
                <a href="http://old.artel.ml/report.html" target="_blank">
                  Старые отчеты
                </a>
              </li>
              <li>
                <a href="http://artel.ml/rekv" target="_blank">
                  Реквизиты
                </a>
              </li>
            </ul>
          </li>
        );
      }
      else if(el.action_name === 'settings'){
        const setsList = sets.map(el => {
          return(
            <li
              className={current===el.action_name ? 'active' : ''}
              key={el.action_name}
              onClick={() => this.navigate(el.action_name)}
            >
              <Link to={"/" + el.action_name}>{el.action_desc}</Link>
            </li>
          );
        });

        return (
          <li
            key='settings'
            className={showSets ? 'dropdown open' : 'dropdown'}
          >
            <a
              href="#"
              onClick={this.toggleSets}
              aria-expanded={showSets ? 'true' : 'false'}
            >
              Настройки <span className="caret"></span>
            </a>
            <ul className="dropdown-menu">
              {setsList}
            </ul>
          </li>
        );
      }
      else if(el.action_name === 'sets_contractor'){
        return (
          <li key={el.action_name} onClick={() => this.navigate('sets_comp')}>
            <Link
              to={"/sets_comp"}
              onClick={this.contractorClick}
            >
              {el.action_desc}
            </Link>
          </li>
        );
      }
      else if(el.action_name === 'places'){
        return (
          <li
            className={current === 'sets_place' ? 'active' : ''}
            key={el.action_name}
            onClick={() => this.navigate('sets_place')}
          >
            <Link
              to={"/sets_place"}
            >
              {el.action_desc}
            </Link>
          </li>
        );
      }
      else{
        return (
          <li
            className={current === el.action_name ? 'active' : ''}
            key={el.action_name}
            onClick={() => this.navigate(el.action_name)}
          >
            <Link to={"/" + el.action_name}>{el.action_desc}</Link>
          </li>
        );
      }
    });

    const userLinks = (
      <div
        onClick={this.hideMenu}
        className={"navbar-collapse collapse" + navClass}
      >
        <ul className="nav navbar-nav">
          {links}
        </ul>
        <ul className="nav navbar-nav navbar-right">
          <li
            onClick={() => this.navigate('userdata')}
            className={current==='userdata' ? 'active' : ''}
          >
            <Link to={"/userdata"} >{displName} {mark}</Link>
          </li>
          <li>
            <a href="#" onClick={this.logout}>
              Выйти <span className="glyphicon glyphicon-log-out"></span>
            </a>
          </li>
        </ul>
      </div>
    );

    const guestLinks = (
      <div
        onClick={this.hideMenu}
        className={"navbar-collapse collapse " + navClass}
      >
        <ul className="nav navbar-nav navbar-right">
          <li
            onClick={() => this.navigate('login')}
            className={current === 'login' ? 'active' : ''}
          >
            <Link to="/login">
              <span className="glyphicon glyphicon-log-in"></span> Войти
            </Link>
          </li>
        </ul>
      </div>
    );

    return (
      <nav className="navbar navbar-default navbar-fixed-top hidden-print">
        {savingScreen}
        {fetchingScreen}
        <div className="container-fluid">
          <div className="navbar-header">
            <Link to="/" className="navbar-brand">
              <img
                height="20"
                width="20"
                alt="Brand"
                src="/img/hexagon.png"
              />
            </Link>
            <Link
              onClick={() => this.navigate('')}
              to="/"
              className="navbar-brand"
            >
              База Артель
            </Link>
            <button
              type="button"
              className="navbar-toggle"
              onClick={this.toggleMenu}
            >
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
          </div>
            { isAuthenticated ? userLinks : guestLinks }
        </div>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    dataState: state.dataState,
    comps: state.comps
  };
}

export default connect(mapStateToProps, { logout, filterSets })(NavigationBar);



// WEBPACK FOOTER //
// ./src/components/NavigationBar.js